export function formatDate(date: Date | string) {
  return new Intl.DateTimeFormat('es-DO', { 
    dateStyle: 'medium', 
    timeStyle: 'short',
  }).format(new Date(date));
}
